<h1 mat-dialog-title
    i18n="Contest Payment Confirm Modal|Contest Payment Confirm modal title@@contest-payment-confirm-modal-title">
  Check Payment Status
</h1>
<div mat-dialog-content #dialogContent class="full-width details-content">
  <contest-payment-confirm [contestId]="contestId"
                           [userId]="userId"
                           [role]="role"
                           [groupId]="groupId"
                           [iFrameMode]="false"
                           (statusChanged)="paymentStatusChanged()"></contest-payment-confirm>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              (clicked)="proceed()"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>
</div>
